import React from 'react';
import { useAppSelector } from '../Store/store.ts';
import { CurrentStepSelector } from '../Selectors/FitAssistantSelectors.ts';
import FitAssistantStep from '../Enums/FitAssistantStep.ts';
import NoFit from '../Components/NoFit/NoFit.tsx';
import OtherFits from '../Components/OtherFits/OtherFits.tsx';
import SelectList from '../Components/SelectList/SelectList.tsx';
import Unconfirmed from '../Components/Unconfirmed/Unconfirmed.tsx';

export const TruckBedBikeRacks = () => {
  const currentStep = useAppSelector(CurrentStepSelector);

  const RenderStep = () => {
    switch (currentStep) {
      case FitAssistantStep.Make:
      case FitAssistantStep.Model:
      case FitAssistantStep.Year:
        return <SelectList />;
      case FitAssistantStep.NoFits:
        return <NoFit />;
      case FitAssistantStep.OtherFits:
        return <OtherFits />;
      case FitAssistantStep.Unconfirmed:
        return <Unconfirmed />;
      default:
        return <></>;
    }
  };

  return <>{RenderStep()}</>;
};

export default TruckBedBikeRacks;
